/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_DefectInputs */

const vi_confirm_return_col_defect = /** @type {(inputs: Confirm_Return_Col_DefectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàng lỗi`)
};

/**

* @param {Confirm_Return_Col_DefectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_defect = /** @type {((inputs?: Confirm_Return_Col_DefectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_DefectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_defect(inputs)
});